import { render, staticRenderFns } from "./LayoutNavbarHorizontalItem.vue?vue&type=template&id=94b3c2ae&v-slot%3Aextension=true&"
import script from "./LayoutNavbarHorizontalItem.vue?vue&type=script&lang=ts&"
export * from "./LayoutNavbarHorizontalItem.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutNavbarHorizontalItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab})
